<template>
    <div class="transfer-reports">
        <div class="row mx-0 mb-1 py-3 align-items-center">
            <div class="d-grid col-12 col-md-6 pb-2 pb-md-0">
                <router-link
                    class="btn btn-secondary"
                    :to="'/transfer/reports/employee_week_overview'"
                >
                    Medewerkers weekoverzicht
                </router-link>
            </div>
            <div class="col">
                Weekoverzicht met diensten en beschikbare medewerkers per vestiging. Inclusief kind-leidster ratio.
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TransferReports',
}
</script>

<style scoped>
.row {
    background-color: rgba(0,0,0,.05);
}
</style>
